import { render, staticRenderFns } from "./CompleteSupervisionModal.vue?vue&type=template&id=54b7fed5"
import script from "./CompleteSupervisionModal.vue?vue&type=script&lang=js"
export * from "./CompleteSupervisionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports